import { createFileRoute } from "@tanstack/react-router"
import { DatasetPage } from "@/dataset"

export const Route = createFileRoute("/(user)/t/$tenantSlug/datasets/$id")({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()

  return <DatasetPage id={id} />
}
